import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { getProductByID } from '../../service/apiService';
import { Baseurl } from '../../service/apiService';
import QuillTextDisplay from '../common/Quiltext/QuillTextDisplay'

const Proddetail = () => {
  const { id } = useParams();
  const [detail, setDetail] = useState({})
  const init = async () => {
    await getProductByID(id).then((res) => {
      if(res){
        setDetail(res?.data)
      }
    }).catch(e => console.log(e))
    }

  useEffect(() => {
    init ()
  },[])

  return (
<>
<div class="">

                        <div class="clearfix"></div>
                        <div class="right-content">
                           <div class="page-head d-flex justify-content-between align-items-center flex-wrap">
                             <h1>PRODUCT DETAILS</h1> 
                           </div>
                           <div class="container-fluid booking-details p-0">
                            <div class="row">
                             <div class="col-lg-5">
                                <div class="row">
                                   <div class="col-lg-12 mb-4">
                                <div class="booking-profile bg-curve" style={{minHeight:'279px'}}>
                                  <div class="d-flex flex-wrap align-items-end">
                                    <div class="min-wid">
                                      <div class="pro-img">
                                    <img src={`${Baseurl}/view/imageupload/${detail?.img}`} alt='prodimg' />   
                                  </div> 
                                  <div class="name-desg pb-2">
                                    <h2>{detail?.name}</h2>
                                  </div>   
                                    </div> 
                                    <div className="pro-details mt-1 ms-sm-4">
                                       <span><i class="fal fa-birthday-cake"></i> {detail?.category?.name} </span><br/>
                                       <span><i class="far fa-phone-alt"></i> {detail?.brand?.name}</span><br/>
                                       <span><i class="far fa-phone-alt"></i> {detail?.type?.name}</span><br/>
                                       <span className="me-3"><i class="fal fa-envelope"></i> <QuillTextDisplay text={detail?.description} /> </span><br/>
                                    </div>
                                  </div>
                                </div>  
                              </div> 
                                </div>
                             </div>
                             <div class="col-lg-7">
                                 <div class="row">
                                  <div class="col-lg-6 mb-4">
                                   <div class="card">
                                     <div class="card-header bg-transparent">
                                    <div className="d-flex text-white justify-content-between flex-wrap mb-3">
                                      <h2>SPECS</h2>
                                    </div>
                                  </div> 
                                  <div className="d-flex text-white seesions flex-wrap justify-content-start">
                                  {
                                    detail?.specs?.length ? <>
                                   { detail?.specs?.map((itm,index) => (
                                    <div key={index} className='ms-2'>
                                        <h5>{itm?.heading}</h5>
                                        <p>{itm?.value}</p>
                                    </div> 
                                    )) }
                                    </> : "No Specs"
                                  }
                                    
                                  </div>
                                 
                                   </div> 
                                  </div>
                                  
                                  <div className="col-lg-6 text-white mb-4">
                                         <div class="card">
                                     <div class="card-header bg-transparent">
                                    <div className="d-flex text-white justify-content-between flex-wrap mb-3">
                                      <h2>PRICE & QUANTITY</h2>
                                    </div>
                                  </div> 
                                  <div className="d-flex text-white seesions justify-content-between">
                            
                                    <div>
                                        <h5>MRPPRICE</h5>
                                        <p>{detail?.mrpprice}</p>
                                    </div> 
                                  <div>
                                        <h5>OURPRICE</h5>
                                        <p>{detail?.ourprice}</p>
                                    </div> 

                                      <div>
                                        <h5>QUANTITY</h5>
                                        <p>{detail?.quantity}</p>
                                    </div> 

                               
                                    
                                  </div>

                                     <div className="d-flex text-white seesions justify-content-between">
                            
                                    {detail?.subimg1 !== undefined ? <div>
                                        <h5>SUB IMAGE ONE</h5>
                                        <p><img src={`${Baseurl}/view/imageupload/${detail?.subimg1}`} alt='prodimg' /></p>
                                    </div> : <></>}
                                 
                                     {detail?.subimg2 !== undefined ? <div>
                                        <h5>SUB IMAGE TWO</h5>
                                        <p><img src={`${Baseurl}/view/imageupload/${detail?.subimg2}`} alt='prodimg' /></p>
                                    </div> : <></>}
                                     
                                      {detail?.subimg3 !== undefined ? <div>
                                        <h5>SUB IMAGE THREE</h5>
                                        <p><img src={`${Baseurl}/view/imageupload/${detail?.subimg3}`} alt='prodimg' /></p>
                                    </div> : <></>}

                               
                                    
                                  </div>
                                 
                                   </div> 
                                 </div>

                                 
                                 </div>
                             </div>


                                 <div class="col-lg-7">
                                 <div class="row">
                                  <div class="col-lg-6 mb-4">
                                   <div class="card">
                                     <div class="card-header bg-transparent">
                                    <div className="d-flex text-white justify-content-between flex-wrap mb-3">
                                      <h2>RATING/ ASSEMBLECHARGE/ TRANSPORTATION</h2>
                                    </div>
                                  </div> 
                                  <div className="d-flex text-white seesions justify-content-between">
                               
                                  
                                    <div >
                                        <h5>averageRating</h5>
                                        <p>{detail?.averageRating}</p>
                                    </div> 

                                    <div >
                                      <h5>ASSEMBLECHARGE</h5>
                                      <p>{detail?.assembleCharge}</p>
                                    </div> 

                                      <div>
                                      <h5>transportationtype</h5>
                                      <p>{detail?.transportationtype}</p>
                                    </div> 
                                
                                  </div>
                                 
                                   </div> 
                                  </div>
    

                                 
                                 </div>
                             </div>



                            </div>
                            </div>
                            </div>
                            {/* <div className="row text-white">
                              <div class="col-lg-8 mb-4">
                               <div class="card bg-curve">
                                 <div class="card-header">
                                    <div class="d-flex justify-content-between flex-wrap">
                                      <h2>Booking STATUS</h2>
                                      <ul class="controls text-end">
                                       <li><span class="icon-label" style={{background:'#D4AF37'}}></span> Completed</li>  
                                       <li><span class="icon-label" style={{background:'#FF4F5A'}}></span> Cancelled</li>  
                                      </ul>
                                    </div>
                                  </div> 
                                  <div id="chart3"></div>
                               </div>   
                             </div>
                             <div class="col-lg-4 mb-4">
                                <div class="card bg-curve">
                                  <div class="card-header">
                                    <div class="d-flex justify-content-between flex-wrap">
                                      <h2 class="mb-3">Booking STATUS</h2>
                                      <h2>16 March 2022</h2>
                                    </div>
                                  </div>
                                  <div class="bc-card-scroll scroll-bar">
                                    <div class="bc-card">
                                    <div class="d-flex justify-content-between align-items-center">
                                      <div><img src="/images/user.png"/> <h5 class="d-inline-block align-middle m-0">JOHN SAMUEL</h5></div> 
                                      <p><i class="fas fa-check-circle"></i> Trainer</p>
                                    </div>
                                      <hr />
                                      <div class="item">
                                        <h5>Football</h5>
                                        <p class="text-uppercase">Penalty shootout</p>
                                      </div>
                                      <hr/>
                                      <div class="session">
                                        <p><i class="fas fa-clock"></i> Session Time is  11:30  - 13:00 </p>
                                      </div>
                                  </div>
                                    <div class="bc-card">
                                    <div class="d-flex justify-content-between align-items-center">
                                      <div><img src="/images/user.png"/> <h5 class="d-inline-block align-middle m-0">JOHN SAMUEL</h5></div> 
                                      <p><i class="fas fa-check-circle"></i> Trainer</p>
                                    </div>
                                      <hr/>
                                      <div class="item">
                                        <h5>Football</h5>
                                        <p class="text-uppercase">Penalty shootout</p>
                                      </div>
                                      <hr/>
                                      <div class="session">
                                        <p><i class="fas fa-clock"></i> Session Time is  11:30  - 13:00 </p>
                                      </div>
                                  </div>
                                  </div>
                                </div> 
                             </div>
                            </div>
                            <div class="row">
                             <div class="col-lg-8 mb-4">
                              <div class="card">
                                <div class="card-header">
                                  <div class="d-flex justify-content-between flex-wrap">
                                      <h2>TRAINERS</h2>
                                      <ul class="nav imp-nav mb-0">
                                          <li class="nav-item">
                                            <a class="nav-link active" data-bs-toggle="tab" href="#home">Waved</a>
                                          </li>
                                          <li class="nav-item">
                                            <a class="nav-link" data-bs-toggle="tab" href="#m1">Paired</a>
                                          </li>
                                          <li class="nav-item">
                                            <a class="nav-link" data-bs-toggle="tab" href="#m2">Declined</a>
                                          </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="tab-content trainers-list">
                                 <div class="tab-pane active" id="home">
                                    <div class="row">
                                      <div class="col-lg-6">
                                        <div class="sessions mt-4">
                                          <div class="d-flex">
                                            <img class="trainer" src="assets/images/trainer.svg"/>
                                            <div class="flex-fill">
                                              <h4>JOHN ALEXANDER</h4>
                                              <p class="mb-1">Football  |  Cricket |  Swimming</p>
                                              <div class="training">
                                               <img src="/images/offline.svg" class="img-fluid"/> <img src="assets/images/online.svg" class="img-fluid online me-1"/> <h6>Online/Offline Training </h6>  
                                              </div>
                                            </div>
                                          </div>      
                                        </div>  
                                      </div>
                                      <div class="col-lg-6">
                                        <div class="sessions mt-4">
                                          <div class="d-flex">
                                            <img class="trainer" src="assets/images/trainer.svg"/>
                                            <div class="flex-fill">
                                              <h4>ARUN GEORGE</h4>
                                              <p class="mb-1">Football  |  Cricket |  Swimming</p>
                                              <div class="training">
                                               <img src="/images/offline.svg" class="img-fluid"/> <img src="assets/images/online.svg" class="img-fluid online me-1"/> <h6>Online/Offline Training </h6>  
                                              </div>
                                            </div>
                                          </div>      
                                        </div>  
                                      </div>
                                      <div class="col-lg-6">
                                        <div class="sessions mt-4">
                                          <div class="d-flex">
                                            <img class="trainer" src="/images/trainer.svg"/>
                                            <div class="flex-fill">
                                              <h4>JOHN ALEXANDER</h4>
                                              <p class="mb-1">Football  |  Cricket |  Swimming</p>
                                              <div class="training">
                                               <img src="/images/offline.svg" class="img-fluid"/> <img src="/images/online.svg" class="img-fluid online me-1"/> <h6>Online/Offline Training </h6>  
                                              </div>
                                            </div>
                                          </div>      
                                        </div>  
                                      </div> 
                                    </div>
                                  </div>
                                 <div class="tab-pane" id="m1">
                                    <div class="row">
                                      <div class="col-lg-6">
                                        <div class="sessions mt-4">
                                          <div class="d-flex">
                                            <img class="trainer" src="/images/trainer.svg"/>
                                            <div class="flex-fill">
                                              <h4>ALEXANDER</h4>
                                              <p class="mb-1">Football  |  Cricket |  Swimming</p>
                                              <div class="training">
                                               <img src="/images/offline.svg" class="img-fluid"/> <img src="/images/online.svg" class="img-fluid online me-1"/> <h6>Online/Offline Training </h6>  
                                              </div>
                                            </div>
                                          </div>      
                                        </div>  
                                      </div>
                                      <div class="col-lg-6">
                                        <div class="sessions mt-4">
                                          <div class="d-flex">
                                            <img class="trainer" src="/images/trainer.svg"/>
                                            <div class="flex-fill">
                                              <h4>GEORGE</h4>
                                              <p class="mb-1">Football  |  Cricket |  Swimming</p>
                                              <div class="training">
                                               <img src="/images/offline.svg" class="img-fluid"/> <img src="/images/online.svg" class="img-fluid online me-1"/> <h6>Online/Offline Training </h6>  
                                              </div>
                                            </div>
                                          </div>      
                                        </div>  
                                      </div>
                                      <div class="col-lg-6">
                                        <div class="sessions mt-4">
                                          <div class="d-flex">
                                            <img class="trainer" src="/images/trainer.svg" />
                                            <div class="flex-fill">
                                              <h4>JOHN ALEXANDER</h4>
                                              <p class="mb-1">Football  |  Cricket |  Swimming</p>
                                              <div class="training">
                                               <img src="/images/offline.svg" class="img-fluid"/> <img src="/images/online.svg" class="img-fluid online me-1"/> <h6>Online/Offline Training </h6>  
                                              </div>
                                            </div>
                                          </div>      
                                        </div>  
                                      </div> 
                                    </div>
                                  </div>
                                 <div class="tab-pane" id="m2">
                                    <div class="row">
                                      <div class="col-lg-6">
                                        <div class="sessions mt-4">
                                          <div class="d-flex">
                                            <img class="trainer" src="/images/trainer.svg"/>
                                            <div class="flex-fill">
                                              <h4>JOHN</h4>
                                              <p class="mb-1">Football  |  Cricket |  Swimming</p>
                                              <div class="training">
                                               <img src="/images/offline.svg" class="img-fluid"/> <img src="/images/online.svg" class="img-fluid online me-1"/> <h6>Online/Offline Training </h6>  
                                              </div>
                                            </div>
                                          </div>      
                                        </div>  
                                      </div>
                                      <div class="col-lg-6">
                                        <div class="sessions mt-4">
                                          <div class="d-flex">
                                            <img class="trainer" src="assets/images/trainer.svg"/>
                                            <div class="flex-fill">
                                              <h4>ARUN</h4>
                                              <p class="mb-1">Football  |  Cricket |  Swimming</p>
                                              <div class="training">
                                               <img src="/images/offline.svg" class="img-fluid"/> <img src="/images/online.svg" class="img-fluid online me-1"/> <h6>Online/Offline Training </h6>  
                                              </div>
                                            </div>
                                          </div>      
                                        </div>  
                                      </div>
                                      <div class="col-lg-6">
                                        <div class="sessions mt-4">
                                          <div class="d-flex">
                                            <img class="trainer" src="/images/trainer.svg"/>
                                            <div class="flex-fill">
                                              <h4>JOHN ALEXANDER</h4>
                                              <p class="mb-1">Football  |  Cricket |  Swimming</p>
                                              <div class="training">
                                               <img src="/images/offline.svg" class="img-fluid"/> <img src="/images/online.svg" class="img-fluid online me-1"/> <h6>Online/Offline Training </h6>  
                                              </div>
                                            </div>
                                          </div>      
                                        </div>  
                                      </div> 
                                    </div>
                                  </div>
                                </div>
                              </div>   
                             </div> 
                             <div class="col-lg-4 mb-4">
                               <div class="card">
                                <div class="card-header">
                                 <h2 class="mb-3">REVIEWS</h2>   
                                </div> 
                                <div class="reviews manage-reviews">
                                        <div>
                                          <img src="/images/user.png"/>
                                        <h4>RONALD andrews</h4>  
                                        </div>
                                        <div>
                                            <span class="fa fa-star"></span>
                                            <span class="fa fa-star"></span>
                                            <span class="fa fa-star"></span>
                                            <span class="far fa-star"></span>
                                            <span class="far fa-star"></span>
                                        </div>
                                        <p>Amet minim mollit non deserunt ullamco est sit aliqua 
dolor do amet sint. </p>
                                </div>
                                <div class="reviews manage-reviews">
                                        <div>
                                          <img src="/images/user.png"/>
                                        <h4>RONALD andrews</h4>  
                                        </div>
                                        <div>
                                          <span class="fa fa-star"></span>
                                            <span class="fa fa-star"></span>
                                            <span class="fa fa-star"></span>
                                            <span class="far fa-star"></span>
                                            <span class="far fa-star"></span>  
                                        </div>
                                        <p>Amet minim mollit non deserunt ullamco est sit aliqua 
dolor do amet sint. </p>
                                </div>
                                <div class="reviews manage-reviews">
                                        <div>
                                          <img src="/images/user.png"/>
                                        <h4>RONALD andrews</h4>  
                                        </div>
                                        <div>
                                          <span class="fa fa-star"></span>
                                            <span class="fa fa-star"></span>
                                            <span class="fa fa-star"></span>
                                            <span class="far fa-star"></span>
                                            <span class="far fa-star"></span>
                                        </div>
                                        <p>Amet minim mollit non deserunt ullamco est sit aliqua 
dolor do amet sint. </p>
                                </div>
                               </div>   
                             </div>
                            </div> */}
                           </div>
</>
  )
}

export default Proddetail
